import { all } from 'redux-saga/effects';
import { watchCreate } from './create';
import { watchList } from './list';
import { watchUpdate } from './update';
import { watchGet } from './get';
import { watchDelete } from './delete';
import watchGetImage from './getImage';

export function* watchMedicalEntities() {
  yield all([
    watchCreate(),
    watchList(),
    watchUpdate(),
    watchGet(),
    watchDelete(),
    watchGetImage(),
  ]);
}
